import { render, staticRenderFns } from "./SaveCorrelation.vue?vue&type=template&id=2a46dc3a&scoped=true"
import script from "./SaveCorrelation.vue?vue&type=script&lang=js"
export * from "./SaveCorrelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a46dc3a",
  null
  
)

export default component.exports